import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { createywkzgrq4l4xy as create } from '../../../../../../../kotlin-react/react/create.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function create_0(_this__u8e3s4, player, className, onClick, size, deselected, tilt, key) {
  className = className === VOID ? null : className;
  onClick = onClick === VOID ? null : onClick;
  size = size === VOID ? null : size;
  deselected = deselected === VOID ? null : deselected;
  tilt = tilt === VOID ? null : tilt;
  key = key === VOID ? null : key;
  return create(_this__u8e3s4, ($this$create) => {
    $this$create.player = player;
    var tmp0_safe_receiver = className;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$create.className = tmp0_safe_receiver;
    }
    var tmp1_safe_receiver = onClick;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$create.onClick = tmp1_safe_receiver;
    }
    var tmp2_safe_receiver = size;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$create.size = tmp2_safe_receiver;
    }
    var tmp3_safe_receiver = deselected;
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$create.deselected = tmp3_safe_receiver;
    }
    var tmp4_safe_receiver = tilt;
    if (tmp4_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$create.tilt = tmp4_safe_receiver;
    }
    var tmp5_safe_receiver = key;
    if (tmp5_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$create.key = tmp5_safe_receiver;
    }
    return Unit_instance;
  });
}
function component1(_this__u8e3s4) {
  return _this__u8e3s4.player;
}
function component2(_this__u8e3s4) {
  return _this__u8e3s4.className;
}
function component3(_this__u8e3s4) {
  return _this__u8e3s4.onClick;
}
//region block: exports
export {
  component1 as component11fr3arkgy5i01,
  component2 as component21pqhrgr8fz3uo,
  component3 as component320i90114p983f,
  create_0 as create2yy2inqp9wvc1,
};
//endregion

//# sourceMappingURL=PlayerCardPropsExtentions.mjs.map
